import { SIDEBAR_COLLAPSED } from '../../shared/utils/app.const';

export interface ICommonState {
  pageLoading: boolean;
  sidebarCollapsed: boolean;
}

function getSidebarCollapsedFromStorage(): boolean {
  if (typeof window !== 'undefined' && window.localStorage) {
    const stored = localStorage.getItem(SIDEBAR_COLLAPSED);
    return stored === 'true';
  }
  return false;
}

export const initialCommonState: ICommonState = {
  pageLoading: false,
  sidebarCollapsed: getSidebarCollapsedFromStorage(),
};
